<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body
            draw(v-if="isBattleDraw" :playMoreRouteString="playMoreRouteString" @showResultStats="showResultStats")
            template(v-else)
                victory(
                    v-if="isVictory"
                    :is-force-completed="isForceCompleted"
                    :playMoreRouteString="playMoreRouteString"
                    :isTrainingBattle="isTrainingBattle"
                    @showResultStats="showResultStats"
                )
                loss(v-else :playMoreRouteString="playMoreRouteString" :is-force-completed="isForceCompleted" @showResultStats="showResultStats")
        battle-result-stats-modal(
            v-if="showResultStatsModal",
            :battle-result-stats="battleResultStats"
            @close="showResultStatsModal = false",
        )
</template>

<script>
    /*eslint-disable*/
    import victory from './Victory.vue';
    import loss from './Loss.vue';
    import draw from './Draw.vue';
    import BattleApi from '../../../api/battle'
    const BattleResultStatsModal = () => import('../../../modals/BattleResultStatsModal.vue')

    export default {
        props: {
            id: [Number, String],
            isVictory: Boolean,
            isBattleDraw: Boolean,
            isTrainingBattle: Boolean,
            isForceCompleted: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                battleResultStats: null,
                showResultStatsModal: false,
            }
        },
        computed: {
            playMoreRouteString() {
                return this.isTrainingBattle ? 'battle-trainings:index' : 'battles:index';
            }
        },
        methods: {
            getBattleResultStats() {
                BattleApi.getBattleResultStats()
                    .then(data => {
                        let statsBeforeProcess = data.battleResultStats;
                        this.battleResultStats = this.processData(statsBeforeProcess);
                    })
                    .catch(err => {
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                        this.showResultStatsModal = false;
                    });
            },
            showResultStats() {
                if (!this.battleResultStats) {
                    this.getBattleResultStats();
                }
                this.showResultStatsModal = !this.showResultStatsModal;
            },
            getAmountOfCorrectAnswersForNavigator(chainOfAttempts) {
                return chainOfAttempts.reduce((acc, example) => {
                    let isCorrectAnswer  = _.find(example, {good: 1});
                    return isCorrectAnswer ? ++acc : acc;
                }, 0);
            },
            processData(stats) {
                stats.forEach(stage => {
                    _.each(stage,game => {
                        if (game.exercise.game === 'Navigator') {
                            game.exercise.answers = this.getAmountOfCorrectAnswersForNavigator(game.exercise.chainOfAttempts);
                            game.opponentExercise.answers = this.getAmountOfCorrectAnswersForNavigator(game.opponentExercise.chainOfAttempts);
                        }
                    })
                });
                return stats;
            },

        },
        components: {
            BattleResultStatsModal,
            victory,
            loss,
            draw,
        }
    }
</script>

<style scoped lang="scss">
    .box {
        overflow-x: hidden;
        position: relative;
        width: 100%;
        height: 100%;
        border-radius: 40px;
        background: #ffffff;
        box-shadow: 0 0 54px #51A552;
        display: flex;
        justify-content: center;
        @media screen and (max-width: 575px) {
            border-radius: 0;
            height: 100vh;
            box-shadow: none;
        }
    }
    .box-body {
        width: 100%;
        padding: $border-radius-40;
    }
</style>
